import { apiCall } from './config';

export const accountValidation = (body, ip) => apiCall('post', '/account/validation-code/introspect', null, ip, body);

export const accountVerification = (body, ip) => apiCall('post', '/account/registration/validation', null, ip, body);

export const registerAccount = (body, ip, enelId) => apiCall('post', `/account/password-change/${enelId}`, null, ip, body);

export const getOneTimePassword = (body, ip) => apiCall('post', '/account/otp/request', null, ip, body);

export const getResetPassword = (body, ip) => apiCall('post', '/account/password-reset/request', null, ip, body);

export const confirmationOffer = (body, ip, params) => apiCall('post', '/fe/offer/confirmation', params, ip, body, true);
